import { useState } from "react";
import EditButton from "../../components/EditButton/EditButton";
import { ContentTypeModuleHeadingEdit } from "../../contentTypes/ContentTypeModuleHeading/ContentTypeModuleHeadingEdit";
import { IconNewContentModule } from "../../icons/newContentModule";
import { IContentDataImage, IContentDataRichText, IContentDataTitle } from "../../interfaces/IContentData";
import { ISiteModuleImageGallery } from "../../interfaces/ISiteModule";
import { ISiteV2 } from "../../interfaces/Site";
import styles from "./SiteModuleImageGallery.module.scss";
import { SiteModuleImageGalleryItemEdit } from "./SiteModuleImageGalleryItem/SiteModuleImageGalleryItemEdit";
import { Dialog } from "../../editComponents/Dialog/Dialog";
import { UploadImages } from "./components/UploadImages/UploadImages";
import { getNewSiteModuleImageGalleryItem } from "../utils/getNewSiteModuleImageGallery";
import { ContentTypeRichTextEdit } from "../../contentTypes/ContentTypeRichText/ContentTypeRichTextEdit";

interface IProps {
    site: ISiteV2;
    siteModule: ISiteModuleImageGallery;
    updateSiteModuleProperty: <SiteModule extends ISiteModuleImageGallery, Property extends keyof SiteModule>(
        property: keyof SiteModule,
        value: SiteModule[Property]
    ) => void;
    updateSiteModule: <SiteModule extends ISiteModuleImageGallery>(updater: (siteModule: SiteModule) => void) => void;
}

export const SiteModuleImageGalleryEdit = (props: IProps) => {
    const [showUpload, setShowUpload] = useState(false);
    const [isUploading, setIsUploading] = useState(false);

    const addImage = (image: IContentDataImage) => {
        props.updateSiteModule((siteModule) => {
            siteModule.gallery.push(getNewSiteModuleImageGalleryItem(image));
        });
    };

    return (
        <section className={styles[props.site.theme]}>
            <Dialog
                closeButton={true}
                open={showUpload}
                handleClose={() => setShowUpload(false)}
                closableByOutsideClickAndEsc={!isUploading}
            >
                <UploadImages isUploading={isUploading} setIsUploading={setIsUploading} onSuccess={() => setShowUpload(false)} site={props.site} updateContentData={addImage} />
            </Dialog>
            <ContentTypeModuleHeadingEdit
                contentData={props.siteModule.title}
                site={props.site}
                updateContentData={(value: IContentDataTitle) => props.updateSiteModuleProperty("title", value)}
            />
            <div className={styles.rteWrapper}>
                <ContentTypeRichTextEdit
                    contentData={props.siteModule.text}
                    site={props.site}
                    updateContentData={(value: IContentDataRichText) => props.updateSiteModuleProperty("text", value)}
                />
            </div>
            {props.siteModule.gallery.length ? (
                <div className={styles.itemsWrapper}>
                    {props.siteModule.gallery.map((listItem) => (
                        <SiteModuleImageGalleryItemEdit
                            site={props.site}
                            gallery={props.siteModule.gallery}
                            listItem={listItem}
                            key={listItem.id}
                            updateSiteModule={props.updateSiteModule}
                        />
                    ))}
                </div>
            ) : null}
            <div className={styles.editButtonWrapper}>
                <EditButton callback={() => setShowUpload(true)}>
                    <>
                        <IconNewContentModule></IconNewContentModule>
                        Lägg till bilder
                    </>
                </EditButton>
            </div>
        </section>
    );
};
